export const selectFactoryRates = (state) => state.factoryRates.rates;
export const selectFactoryRatesLoading = (state) => state.factoryRates.loading;
export const selectFactoryRatesError = (state) => state.factoryRates.error;